export default __webpack_public_path__ + "static/media/mail.1d3d0618.svg";